/* eslint-disable */
import React, { useState, useRef, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Typography,
  makeStyles,
  FormControlLabel,
  Checkbox,
  Tabs,
  Tab,
  Box,
  Fade,
} from '@material-ui/core';
import { Form, Field } from 'formik';
import { useSelector } from 'react-redux';
import FeaturesSection from './widgets/FeaturesSection/FeaturesSection';
import BasicInfoSection from './widgets/BasicInfoSection';
import ScheduledActivitiesSection from './widgets/ScheduledActivitiesSection';
import OtherAddressesSection from './widgets/OtherAddressesSection';
import CustomEmailSection from './widgets/CustomEmailSection/CustonEmailSection';
import CustomTagsSelector from './widgets/CustomTags';
import AddressForm from '../AddressForm';
import ClaimReportTypeSection from './widgets/ClaimReportTypeSection/ClaimReportTypeSection';
import { checkPermission } from '../../../../helpers/checkPermissions';
import permissions from '../../../../config/permissions';

const useStyles = makeStyles((theme) => ({
  checkbox: {
    margin: theme.spacing(0, 0, 2.25, 0),
  },
  dataContainer: {
    width: '100%',
    maxWidth: 1400,
    paddingTop: 10,
  },
  sectionContent: {
    width: '100%',
    maxWidth: 1000,
  },
  section: {
    width: '100%',
    marginBottom: theme.spacing(3),
    padding: theme.spacing(4),
    background: '#ffffff',
    borderRadius: 12,
    border: '1px solid rgba(0, 0, 0, 0.08)',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
    [theme.breakpoints.down('md')]: {
      marginBottom: theme.spacing(2.5),
      padding: theme.spacing(3),
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(2),
      padding: theme.spacing(2),
      borderRadius: 8,
    },
  },
  sectionTitle: {
    fontSize: '1.1rem',
    fontWeight: 600,
    color: theme.colors.blue2,
    marginBottom: theme.spacing(1.5),
    paddingBottom: theme.spacing(1),
    borderBottom: `2px solid ${theme.colors.lightBlue}`,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1rem',
      marginBottom: theme.spacing(1),
    },
  },
  tabsContainer: {
    // background: '#f8f9fa',
    borderRadius: '0',
    border: 'none',
    boxShadow: 'none',
    marginBottom: 0,
    padding: '0 20px',
    position: 'sticky',
    top: 0,
    zIndex: 10,
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: 1,
      background: 'linear-gradient(90deg, rgba(0,168,255,0.2) 0%, rgba(0,168,255,0.1) 50%, rgba(0,168,255,0.2) 100%)',
    },
  },
  tabs: {
    minHeight: 54,
    paddingTop: 16,
    '& .MuiTabs-indicator': {
      display: 'none',
    },
    '& .MuiTabs-flexContainer': {
      gap: '4px',
      alignItems: 'flex-end',
      paddingTop: 16,
      paddingLeft: 16,
    },
    '& .MuiTab-root': {
      textTransform: 'none',
      fontWeight: 500,
      fontSize: '0.8rem',
      color: '#6b7280',
      padding: theme.spacing(1.5, 3),
      minWidth: 140,
      minHeight: 48,
      position: 'relative',
      borderRadius: '12px 12px 0 0',
      background: 'linear-gradient(145deg, #ffffff 0%, #f8fafc 100%)',
      border: '1px solid #e5e7eb',
      borderBottom: 'none',
      marginBottom: 0,
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.05)',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 8,
        left: 12,
        right: 12,
        height: 2,
        // background: 'linear-gradient(90deg, transparent 0%, rgba(0,168,255,0.3) 50%, transparent 100%)',
        borderRadius: 1,
        opacity: 0,
        transition: 'opacity 0.3s ease',
      },
      '&:hover': {
        color: '#374151',
        background: 'linear-gradient(145deg, #ffffff 0%, #f1f5f9 100%)',
        transform: 'translateY(-2px)',
        boxShadow: '0 -4px 16px rgba(0, 168, 255, 0.12)',
        '&::before': {
          opacity: 1,
        },
      },
      [theme.breakpoints.down('md')]: {
        fontSize: '0.75rem',
        padding: theme.spacing(1.25, 2.5),
        minWidth: 120,
      },
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.7rem',
        padding: theme.spacing(1, 2),
        minWidth: 100,
      },
    },
    '& .MuiTab-root.Mui-selected': {
      color: theme.colors.blue2,
      background: 'linear-gradient(145deg, #ffffff 0%, #ffffff 100%)',
      borderColor: '#00A8FF',
      borderWidth: '2px 2px 0 2px',
      borderStyle: 'solid',
      zIndex: 2,
      transform: 'translateY(-1px)',
      boxShadow: '0 -6px 20px rgba(0, 168, 255, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.9)',
      // '&::before': {
      //   opacity: 1,
      //   background: 'linear-gradient(90deg, transparent 0%, #00A8FF 50%, transparent 100%)',
      // },
      '&::after': {
        content: '""',
        position: 'absolute',
        bottom: -1,
        left: -1,
        right: -1,
        height: 2,
        background: '#ffffff',
        zIndex: 1,
      },
    },
    '& .MuiTab-root.tab-error': {
      borderColor: '#dc3545 !important',
      color: '#dc3545 !important',
      background: 'linear-gradient(145deg, #fff5f5 0%, #fef2f2 100%) !important',
      '&::before': {
        opacity: '1 !important',
      },
      '&:hover': {
        background: 'linear-gradient(145deg, #fef2f2 0%, #fed7d7 100%) !important',
        boxShadow: '0 -4px 16px rgba(220, 53, 69, 0.15) !important',
      },
    },
    '& .MuiTab-root.tab-error.Mui-selected': {
      borderColor: '#dc3545 !important',
      color: '#dc3545 !important',
      background: 'linear-gradient(145deg, #ffffff 0%, #ffffff 100%) !important',
      boxShadow: '0 -6px 20px rgba(220, 53, 69, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.9) !important',
      '&::after': {
        background: '#ffffff !important',
      },
    },
  },
  tabPanel: {
    width: '100%',
    // background: '#ffffff',
    // borderRadius: '0 12px 12px 12px',
    // border: '2px solid #00A8FF',
    // borderTop: 'none',
    // boxShadow: '0 4px 20px rgba(0, 168, 255, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04)',
    // margin: '0 20px',
    // position: 'relative',
    // maxHeight: 'calc(100vh - 200px)',
    // overflow: 'auto',
    // '&::before': {
    //   content: '""',
    //   position: 'absolute',
    //   top: -2,
    //   left: -2,
    //   right: -2,
    //   height: 4,
    //   background: 'linear-gradient(90deg, #00A8FF 0%, rgba(0,168,255,0.7) 50%, #00A8FF 100%)',
    //   borderRadius: '0 12px 0 0',
    // },
    // [theme.breakpoints.down('md')]: {
    //   margin: '0 16px',
    //   maxHeight: 'calc(100vh - 180px)',
    // },
    // [theme.breakpoints.down('sm')]: {
    //   margin: '0 12px',
    //   maxHeight: 'calc(100vh - 160px)',
    // },
  },
  tabPanelContent: {
    padding: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(3),
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  fadeContainer: {
    position: 'relative',
    width: '100%',
  },
  tabPanelWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    opacity: 0,
    visibility: 'hidden',
    transition: 'opacity 0.15s ease-in-out, visibility 0.15s ease-in-out',
    '&.active': {
      opacity: 1,
      visibility: 'visible',
      position: 'relative',
    },
  },
  formCard: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    background: '#ffffff',
    borderRadius: 16,
    boxShadow: '0 4px 24px rgba(0, 0, 0, 0.08)',
    overflow: 'hidden',
    marginBottom: theme.spacing(10), // Space for actions
    margin: theme.spacing(3, 0),
    marginTop: 0,
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(2, 0),
      borderRadius: 12,
    },
  },
  scrollableContent: {
    flex: 1,
    overflow: 'auto',
    background: 'linear-gradient(135deg, #fafafa 0%, #ffffff 100%)',
  },
  formContent: {
    width: '100%',
  },
}));

// TabPanel component
function TabPanel(props) {
  const { children, value, index, classes, ...other } = props;

  return (
    <Fade in={value === index} timeout={300} unmountOnExit>
      <div
        role='tabpanel'
        id={`account-tabpanel-${index}`}
        aria-labelledby={`account-tab-${index}`}
        className={classes.tabPanelContent}
        {...other}
      >
        {children}
      </div>
    </Fade>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  classes: PropTypes.object.isRequired,
};

function a11yProps(index) {
  return {
    id: `account-tab-${index}`,
    'aria-controls': `account-tabpanel-${index}`,
  };
}

const AccountForm = ({
                       values,
                       backendErrors,
                       isEditMode,
                       validateForm,
                       validateField,
                       setErrors,
                       accountUuid,
                       setAccount,
                       setBackendErrors,
                       surveysPayload,
                       resourcesPayload,
                       surveysLoading,
                       resourcesLoading,
                     }) => {
  const classes = useStyles();
  const { en: { forms } } = useSelector((state) => state.i18n);
  const {
    metadata: { currentAccount, childAccountPermissions },
    isDistributionSponsor,
  } = useSelector((state) => state.user);
  const [activeTab, setActiveTab] = useState(0);
  const scrollableContentRef = useRef(null);
  const permissionsForShowingOptions = useMemo(
    () => ({
      canDisableOrders: checkPermission(
        childAccountPermissions,
        permissions.ACCOUNT_PATCH_DISABLE_ORDERS,
      ),
      canDisableAssessments: checkPermission(
        childAccountPermissions,
        permissions.ACCOUNT_PATCH_DISABLE_ASSESSMENTS,
      ),
      canDisableAllergiendResources: checkPermission(
        childAccountPermissions,
        permissions.ACCOUNT_PATCH_ALLERGIEND_RESOURCES,
      ),
      canEnableClaimsManagement: checkPermission(
        childAccountPermissions,
        permissions.ACCOUNT_PATCH_ENABLE_CLAIM_MANAGEMENT,
      ),
      canDisableResources: checkPermission(
        childAccountPermissions,
        permissions.ACCOUNT_PATCH_RESOURCE_ALL,
      ),
      canEnableImmunotherapyReport: checkPermission(
        childAccountPermissions,
        permissions.ACCOUNT_PATCH_DISABLE_ORDERS,
      ),
    }),
    [childAccountPermissions],
  );

  const {
    canDisableAssessments,
    canDisableAllergiendResources,
    canDisableResources,
    canDisableOrders,
    canEnableClaimsManagement,
    canEnableImmunotherapyReport,
  } = permissionsForShowingOptions;

  const isAnyDisableFeaturesAvailable = canDisableAssessments
    || canDisableAllergiendResources
    || canDisableResources;

  const isAnyEnableFeaturesAvailable = canDisableOrders
    || canEnableClaimsManagement
    || canEnableImmunotherapyReport;

  const isAnyFeaturesAvailable =
    isAnyDisableFeaturesAvailable || isAnyEnableFeaturesAvailable;

  const isCurrentAccountEditing = currentAccount.uuid === accountUuid;

  // Function to clear backend error for a specific field
  const clearBackendError = (fieldName) => {
    if (setBackendErrors && backendErrors && backendErrors[fieldName]) {
      const updatedErrors = { ...backendErrors };
      delete updatedErrors[fieldName];
      setBackendErrors(updatedErrors);
    }
  };

  // Function to check if tab has errors
  const getTabErrors = (tabIndex) => {
    if (!backendErrors) return [];

    const errorKeys = Object.keys(backendErrors).filter(key => backendErrors[key]);

    switch (tabIndex) {
      case 0: // Basic Information
        return errorKeys.filter(key => [
          'businessName', 'tradeName', 'phone', 'fax', 'contactName',
          'headProviderName', 'customIdentifier', 'scheduleDeliverTime',
          'customTags'
        ].includes(key));

      case 1: // Addresses
        return errorKeys.filter(key => [
          'organizationAddress', 'shippingAddress', 'otherAddresses'
        ].some(prefix => key.startsWith(prefix)));

      case 2: // Features
        return errorKeys.filter(key => [
          'disableAssessments', 'disableOrders', 'allowedSurveys',
          'disableResourcesAll', 'allowedResources', 'claimReportType'
        ].includes(key));

      case 3: // Settings
        return errorKeys.filter(key => [
          'customEmailSection'
        ].some(prefix => key.startsWith(prefix)));

      default:
        return [];
    }
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);

    // Reset scroll position to top instantly
    if (scrollableContentRef.current) {
      scrollableContentRef.current.scrollTo({
        top: 0,
        behavior: 'auto', // No animation for instant scroll
      });
    }
  };

  return <>
    {/* Tabs Navigation */}
    <div className={classes.tabsContainer}>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        className={classes.tabs}
        variant='standard'
      >
        <Tab
          label='BASIC INFORMATION'
          {...a11yProps(0)}
          className={getTabErrors(0).length > 0 ? 'tab-error' : ''}
        />
        <Tab
          label='ADDRESSES'
          {...a11yProps(1)}
          className={getTabErrors(1).length > 0 ? 'tab-error' : ''}
        />
        {(isDistributionSponsor || isAnyFeaturesAvailable) &&
          <Tab
            label='FEATURES'
            {...a11yProps(2)}
            className={getTabErrors(2).length > 0 ? 'tab-error' : ''}
          />}
        {isDistributionSponsor &&
          <Tab
            label='SETTINGS'
            {...a11yProps(3)}
            className={getTabErrors(3).length > 0 ? 'tab-error' : ''}
          />}
      </Tabs>
    </div>

    <div className={classes.formCard}>
      <div className={classes.scrollableContent} ref={scrollableContentRef}>
        <div className={classes.formContent}>
          <Form>
            <Grid container direction='column' alignItems='flex-start'>

              {/* Tab Panels */}
              <div className={classes.fadeContainer}>
                {/* All TabPanels are rendered but only one is visible with fade effect */}
                <TabPanel value={activeTab} index={0} classes={classes}>
                  {/* Account Type Section */}
                  <div className={classes.section}>
                    <Typography className={classes.sectionTitle}>
                      {forms.accountType}
                    </Typography>
                    <Grid container className={classes.dataContainer}>
                      <Grid item xs={12} md={6} lg={4} container>
                        <Field name='customTags' type='selector'>
                          {({ form }) => {
                            return <CustomTagsSelector
                              values={values}
                              backendErrors={backendErrors}
                              form={form}
                              clearBackendError={clearBackendError}
                            />;
                          }}
                        </Field>
                      </Grid>
                    </Grid>
                  </div>

                  {/* Basic Information Section */}
                  <div className={classes.section}>
                    <Typography className={classes.sectionTitle}>
                      {forms.basicInfo}
                    </Typography>
                    <div className={classes.sectionContent}>
                      <BasicInfoSection
                        values={values}
                        backendErrors={backendErrors}
                        isEditMode={isEditMode}
                        isCurrentAccountEditing={isCurrentAccountEditing}
                        isDistributionSponsor={isDistributionSponsor}
                        clearBackendError={clearBackendError}
                      />
                    </div>
                  </div>

                  {/* Scheduled Activities Section */}
                  <div className={classes.section}>
                    <Typography className={classes.sectionTitle}>
                      {forms.scheduledActivities}
                    </Typography>
                    <div className={classes.sectionContent}>
                      <ScheduledActivitiesSection
                        scheduleDeliverTime={values.scheduleDeliverTime}
                      />
                    </div>
                  </div>
                </TabPanel>

                <TabPanel value={activeTab} index={1} classes={classes}>
                  {/* Organization Address Section */}
                  <div className={classes.section}>
                    <Typography className={classes.sectionTitle}>
                      {forms.organizationAddress}
                    </Typography>
                    <div className={classes.sectionContent}>
                      <AddressForm
                        prefix='organizationAddress'
                        backendErrors={backendErrors}
                        clearBackendError={clearBackendError}
                      />
                    </div>
                  </div>

                  {/* Shipping Address Section */}
                  <div className={classes.section}>
                    <Typography className={classes.sectionTitle}>
                      {forms.shippingAddress}
                    </Typography>
                    <div className={classes.sectionContent}>
                      <Field name='isShippingTheSame' type='checkbox'>
                        {({ field, form }) => (
                          <FormControlLabel
                            control={
                              <Checkbox
                                name={field.name}
                                checked={field.value}
                                color='primary'
                                onChange={(e, checked) => {
                                  form.setFieldValue(field.name, checked);
                                }}
                              />
                            }
                            className={classes.checkbox}
                            label={forms.useSameAddress}
                          />
                        )}
                      </Field>
                      <AddressForm
                        prefix='shippingAddress'
                        backendErrors={values.isShippingTheSame ? undefined : backendErrors}
                        disabled={values.isShippingTheSame}
                        clearBackendError={clearBackendError}
                      />
                    </div>
                  </div>

                  {/* Other Addresses Section */}
                  <div className={classes.section}>
                    <Typography className={classes.sectionTitle}>
                      {forms.otherAddresses}
                    </Typography>
                    <div className={classes.sectionContent}>
                      <OtherAddressesSection
                        otherAddresses={values.otherAddresses}
                        backendErrors={backendErrors}
                        validateForm={validateForm}
                        clearBackendError={clearBackendError}
                      />
                    </div>
                  </div>
                </TabPanel>

                <TabPanel value={activeTab} index={2} classes={classes}>
                  {/* Features Section */}
                  {isAnyFeaturesAvailable &&
                    <div className={classes.section}>
                      <Typography className={classes.sectionTitle}>
                        {forms.features}
                      </Typography>
                      <div className={classes.sectionContent}>
                        <FeaturesSection
                          canDisableOrders={canDisableOrders}
                          canDisableAllergiendResources={canDisableAllergiendResources}
                          canEnableClaimsManagement={canEnableClaimsManagement}
                          canDisableAssessments={canDisableAssessments}
                          canEnableImmunotherapyReport={canEnableImmunotherapyReport}
                          canDisableResources={canDisableResources}
                          clearBackendError={clearBackendError}
                          backendErrors={backendErrors}
                          surveysPayload={surveysPayload}
                          resourcesPayload={resourcesPayload}
                        />
                      </div>
                    </div>
                  }
                  {isDistributionSponsor && (
                    <div className={classes.section}>
                      <Typography className={classes.sectionTitle}>
                        {forms.claimReportType || 'Claim Report Type'}
                      </Typography>
                      <div className={classes.sectionContent}>
                        <ClaimReportTypeSection
                          backendErrors={backendErrors}
                          values={values}
                          validateField={validateField}
                          validateForm={validateForm}
                          setErrors={setErrors}
                        />
                      </div>
                    </div>
                  )}
                </TabPanel>

                <TabPanel value={activeTab} index={3} classes={classes}>
                  {/* Custom Email Section */}
                  <div className={classes.section}>
                    <Typography className={classes.sectionTitle}>
                      {forms.customEmailSettings || 'Email & SMS Settings'}
                    </Typography>
                    <div className={classes.sectionContent}>
                      <Field name='customEmailSection' type='checkbox'>
                        {({ form }) => (
                          <CustomEmailSection
                            backendErrors={backendErrors}
                            form={form}
                            isDistributionSponsor={isDistributionSponsor}
                            setAccount={setAccount}
                            clearBackendError={clearBackendError}
                          />
                        )}
                      </Field>
                    </div>
                  </div>
                </TabPanel>
              </div>
            </Grid>
          </Form>
        </div>
      </div>
    </div>
  </>;
};

AccountForm.propTypes = {
  values: PropTypes.shape({
    otherAddresses: PropTypes.array,
    isShippingTheSame: PropTypes.bool,
    tradeName: PropTypes.string,
    businessName: PropTypes.string,
    scheduleDeliverTime: PropTypes.string,
  }).isRequired,
  sectionClassName: PropTypes.string,
  sectionTitleClassName: PropTypes.string,
  backendErrors: PropTypes.shape({
    businessName: PropTypes.string,
    tradeName: PropTypes.string,
    phone: PropTypes.string,
    fax: PropTypes.string,
    contactName: PropTypes.string,
    headProviderName: PropTypes.string,
    customIdentifier: PropTypes.string,
  }),
  isEditMode: PropTypes.bool,
  validateForm: PropTypes.func.isRequired,
  accountUuid: PropTypes.string.isRequired,
  setBackendErrors: PropTypes.func,
};

AccountForm.defaultProps = {
  backendErrors: undefined,
  isEditMode: false,
};

export default AccountForm;
